import { format } from "date-fns";

/**
 *
 * @param value ISODatetime string
 * @returns
 */

function formatISOtoDDMMYYYY(value: string) {
  return format(new Date(value.toString()), "dd/MM/yyyy");
}

export default formatISOtoDDMMYYYY;
